/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MappaPastoScuola } from './mappa-pasto-scuola';
import { PagoPaConfigForm } from './pago-pa-config-form';


export interface ServizioMensaUpdateForm { 
    version: number;
    gestione_manuale?: boolean;
    orario_massimo_per_annullamento_pasto?: string;
    tipo_pagamento?: ServizioMensaUpdateFormTipoPagamentoEnum;
    stato_ricarica_manuale?: ServizioMensaUpdateFormStatoRicaricaManualeEnum;
    soglia_promemoria_giorni?: number;
    soglia_sospensione_giorni?: number;
    soglia_promemoria_importo?: number;
    soglia_sospensione_importo?: number;
    intervallo_reinvio_promemoria_giorni?: number;
    ore_verifica_ritardo?: number;
    webhook_segnalazioni?: string;
    assistenza_email?: string;
    mappa_pasti_scuola?: Array<MappaPastoScuola>;
    importo_massimo_ricarica?: number;
    pago_pa_config?: PagoPaConfigForm;
    giorno_promemoria_debito?: number;
    conguaglio_abilitato?: boolean;
    tariffe_visibili_cittadino?: boolean;
}
export enum ServizioMensaUpdateFormTipoPagamentoEnum {
    NON_GESTITO = 'NON_GESTITO',
    MANUALE = 'MANUALE',
    PAGO_PA_RICARICHE = 'PAGO_PA_RICARICHE',
    PAGO_PA_RENDICONTAZIONE_E_RICARICHE = 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE',
    PAGO_PA_RENDICONTAZIONE = 'PAGO_PA_RENDICONTAZIONE'
};
export enum ServizioMensaUpdateFormStatoRicaricaManualeEnum {
    ATTIVA = 'ATTIVA',
    NON_ATTIVA = 'NON_ATTIVA'
};



